import { SET_ACCESS_REQUESTS } from '../reducers/accessRequests';

export const actionSetAccessRequests = (accessRequests) => ({
  type: SET_ACCESS_REQUESTS,
  payload: accessRequests,
});
